module.exports = __webpack_public_path__ + "static/media/Roboto-Regular.73f0a88b.woff2";